import React, { useEffect, useState } from "react";
import { IVISAxios } from "../../Modules/Axios/IVISAxios";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";
import TextFiled from "@mui/material/TextField";
import styled from "styled-components";
const CreatePage = () => {
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [text, setText] = useState("");

  const history = useHistory();
  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };

  const onChangeAuthor = (e) => {
    setAuthor(e.target.value);
  };
  const onChangeText = (e) => {
    setText(e.target.value);
  };
  const CreateHandler = async () => {
    try {
      const result = await IVISAxios.post(
        "/Board",
        new URLSearchParams({
          title: title,
          author: author,
          text: text,
        })
      );
      console.log(result);
      history.push("/BoardPage");
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <LayoutBox>
      <h3>글쓰기 페이지</h3>
      제목 : <TextFiled onChange={onChangeTitle} />
      <br />
      작성자 : <TextFiled onChange={onChangeAuthor} />
      <br />
      내용 : <TextFiled onChange={onChangeText} />
      <br />
      <a href="/BoardPage">
        <Button>이전</Button>
      </a>
      <Button onClick={CreateHandler}>게시글 작성</Button>
    </LayoutBox>
  );
};

export default CreatePage;

const LayoutBox = styled.div`
  margin-top: 50px;
  margin-left: 200px;
  margin-right: 200px;
`;
